import { render, staticRenderFns } from "./DeleteWarningModal.vue?vue&type=template&id=3bd8d6c0&scoped=true"
import script from "./DeleteWarningModal.vue?vue&type=script&lang=js"
export * from "./DeleteWarningModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteWarningModal.vue?vue&type=style&index=0&id=3bd8d6c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8d6c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd8d6c0')) {
      api.createRecord('3bd8d6c0', component.options)
    } else {
      api.reload('3bd8d6c0', component.options)
    }
    module.hot.accept("./DeleteWarningModal.vue?vue&type=template&id=3bd8d6c0&scoped=true", function () {
      api.rerender('3bd8d6c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DeleteWarningModal.vue"
export default component.exports